import React from 'react';
import { createRoot } from 'react-dom/client';
import WidgetApp from './WidgetApp';
import './widget.css';

// Inject CSS if it wasn't already injected by Vite
if (!document.getElementById('assist-widget-styles')) {
  const styleElement = document.createElement('style');
  styleElement.id = 'assist-widget-styles';
  styleElement.textContent = `
    :root {
      --assist-primary: #5f6af2;
      --assist-bg: #ffffff;
      --assist-border: #dfe3ee;
      --assist-shadow: rgba(15, 23, 42, 0.15);
      --assist-z-index: 2147483646;
    }
    
    .assist-toggle-button {
      position: fixed !important;
      width: 40px !important;
      height: 40px !important;
      border-radius: 4px !important;
      border: 1px solid #e5e7eb !important;
      background: #ffffff !important;
      color: #2563eb !important;
      cursor: pointer !important;
      box-shadow: none !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      z-index: 2147483647 !important;
      transition: background-color 0.2s ease, border-color 0.2s ease, transform 0.1s ease !important;
      padding: 0 !important;
      margin: 0 !important;
    }
    
    .assist-toggle-button:hover {
      background: #f3f4f6 !important;
      border-color: #d1d5db !important;
    }
    
    .assist-toggle-button:active {
      background: #e5e7eb !important;
      transform: scale(0.98) !important;
    }
    
    .assist-icon {
      width: 20px !important;
      height: 20px !important;
      display: block !important;
    }
    
    .assist-panel {
      position: fixed !important;
      top: 0 !important;
      right: -420px !important;
      width: 420px !important;
      height: 100vh !important;
      max-height: 100vh !important;
      background: #ffffff !important;
      box-shadow: -4px 0 20px rgba(15, 23, 42, 0.15) !important;
      z-index: 2147483647 !important;
      display: flex !important;
      flex-direction: column !important;
      transition: right 0.3s ease !important;
      border-left: 1px solid #dfe3ee !important;
      visibility: visible !important;
      opacity: 1 !important;
      overflow: hidden !important;
    }
    
    .assist-panel.open {
      right: 0 !important;
    }
    
    .assist-panel-header {
      padding: 1.25rem 1.5rem !important;
      border-bottom: 1px solid #dfe3ee !important;
      display: flex !important;
      justify-content: space-between !important;
      align-items: center !important;
    }
    
    .assist-panel-header h3 {
      margin: 0 !important;
      font-size: 1.1rem !important;
      color: #1f2937 !important;
    }
    
    .assist-panel-subtitle {
      margin: 0.25rem 0 0 !important;
      font-size: 0.8rem !important;
      color: #6b7280 !important;
      max-width: 280px !important;
      word-break: break-all !important;
    }
    
    .assist-close {
      border: none !important;
      background: transparent !important;
      font-size: 1.3rem !important;
      cursor: pointer !important;
      color: #6b7280 !important;
    }
    
    .assist-back {
      border: none !important;
      background: transparent !important;
      font-size: 1.5rem !important;
      cursor: pointer !important;
      color: #5f6af2 !important;
      padding: 0.25rem 0.5rem !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      transition: color 0.2s ease, transform 0.1s ease !important;
    }
    
    .assist-back:hover {
      color: #4c56d9 !important;
      transform: translateX(-2px) !important;
    }
    
    .assist-back:active {
      transform: translateX(-4px) !important;
    }
    
    .assist-panel-body {
      flex: 1 !important;
      overflow-y: auto !important;
      padding: 1.25rem 1.5rem !important;
      display: flex !important;
      flex-direction: column !important;
      gap: 1rem !important;
    }
    
    .assist-rule-list {
      display: flex !important;
      flex-direction: column !important;
      gap: 0.5rem !important;
    }
    
    .assist-rule-button {
      border: 1px solid #dfe3ee !important;
      border-radius: 6px !important;
      background: #f5f7ff !important;
      padding: 0.75rem !important;
      text-align: left !important;
      cursor: pointer !important;
      font-size: 0.95rem !important;
      color: #1f2937 !important;
      transition: border-color 0.2s ease, background 0.2s ease !important;
    }
    
    .assist-rule-button:hover {
      border-color: #5f6af2 !important;
    }
    
    .assist-rule-button.active {
      border-color: #5f6af2 !important;
      background: #eaedff !important;
    }
    
    .assist-response-container {
      border-top: 1px solid #dfe3ee !important;
      padding-top: 1rem !important;
    }
    
    .assist-response h4 {
      margin: 0 0 0.5rem !important;
      color: #1f2937 !important;
    }
    
    .assist-response h5 {
      margin: 1rem 0 0.5rem !important;
      color: #374151 !important;
    }
    
    .assist-response ul {
      padding-left: 1rem !important;
      margin: 0 !important;
      list-style: disc !important;
    }
    
    .assist-response li {
      margin-bottom: 0.5rem !important;
      color: #4b5563 !important;
      font-size: 0.9rem !important;
    }
    
    .assist-answer {
      background: #f9fafb !important;
      padding: 0.75rem !important;
      border-radius: 6px !important;
      border: 1px solid #dfe3ee !important;
      line-height: 1.6 !important;
      color: #1f2937 !important;
    }
    
    .assist-answer h1,
    .assist-answer h2,
    .assist-answer h3,
    .assist-answer h4,
    .assist-answer h5,
    .assist-answer h6 {
      margin: 1rem 0 0.5rem 0 !important;
      font-weight: 600 !important;
      color: #1f2937 !important;
      line-height: 1.3 !important;
    }
    
    .assist-answer h1 {
      font-size: 1.5rem !important;
      border-bottom: 2px solid #dfe3ee !important;
      padding-bottom: 0.5rem !important;
    }
    
    .assist-answer h2 {
      font-size: 1.3rem !important;
      border-bottom: 1px solid #dfe3ee !important;
      padding-bottom: 0.3rem !important;
    }
    
    .assist-answer h3 {
      font-size: 1.1rem !important;
    }
    
    .assist-answer h4 {
      font-size: 1rem !important;
    }
    
    .assist-answer p {
      margin: 0.75rem 0 !important;
      line-height: 1.6 !important;
    }
    
    .assist-answer p:first-child {
      margin-top: 0 !important;
    }
    
    .assist-answer p:last-child {
      margin-bottom: 0 !important;
    }
    
    .assist-answer ul,
    .assist-answer ol {
      margin: 0.75rem 0 !important;
      padding-left: 1.5rem !important;
    }
    
    .assist-answer li {
      margin: 0.25rem 0 !important;
      line-height: 1.6 !important;
    }
    
    .assist-answer code {
      background: #f3f4f6 !important;
      padding: 0.125rem 0.375rem !important;
      border-radius: 3px !important;
      font-family: 'Courier New', Courier, monospace !important;
      font-size: 0.9em !important;
      color: #dc2626 !important;
    }
    
    .assist-answer pre {
      background: #1f2937 !important;
      color: #f9fafb !important;
      padding: 1rem !important;
      border-radius: 6px !important;
      overflow-x: auto !important;
      margin: 1rem 0 !important;
    }
    
    .assist-answer pre code {
      background: transparent !important;
      padding: 0 !important;
      color: inherit !important;
      font-size: 0.875rem !important;
    }
    
    .assist-answer blockquote {
      border-left: 4px solid #5f6af2 !important;
      padding-left: 1rem !important;
      margin: 1rem 0 !important;
      color: #4b5563 !important;
      font-style: italic !important;
    }
    
    .assist-answer a {
      color: #5f6af2 !important;
      text-decoration: underline !important;
      transition: color 0.2s ease !important;
    }
    
    .assist-answer a:hover {
      color: #4c56d9 !important;
    }
    
    .assist-answer strong {
      font-weight: 600 !important;
      color: #1f2937 !important;
    }
    
    .assist-answer em {
      font-style: italic !important;
    }
    
    .assist-answer hr {
      border: none !important;
      border-top: 1px solid #dfe3ee !important;
      margin: 1.5rem 0 !important;
    }
    
    .assist-answer table {
      width: 100% !important;
      border-collapse: collapse !important;
      margin: 1rem 0 !important;
    }
    
    .assist-answer th,
    .assist-answer td {
      border: 1px solid #dfe3ee !important;
      padding: 0.5rem !important;
      text-align: left !important;
    }
    
    .assist-answer th {
      background: #f3f4f6 !important;
      font-weight: 600 !important;
    }
    
    .assist-status {
      color: #4b5563 !important;
      font-size: 0.9rem !important;
    }
    
    .assist-loading {
      display: flex !important;
      flex-direction: column !important;
      align-items: center !important;
      justify-content: center !important;
      padding: 2rem !important;
      gap: 1rem !important;
    }
    
    .assist-spinner {
      width: 40px !important;
      height: 40px !important;
      border: 4px solid #e5e7eb !important;
      border-top: 4px solid #5f6af2 !important;
      border-radius: 50% !important;
      animation: assist-spin 1s linear infinite !important;
    }
    
    @keyframes assist-spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
    
    .assist-error {
      color: #dc2626 !important;
      font-size: 0.9rem !important;
    }
    
    .assist-placeholder {
      color: #6b7280 !important;
      font-size: 0.9rem !important;
    }
    
    /* Mode tabs */
    .assist-mode-tabs {
      display: flex !important;
      border-bottom: 1px solid #dfe3ee !important;
      padding: 0 !important;
      flex-shrink: 0 !important;
    }

    .assist-mode-tab {
      flex: 1 !important;
      padding: 0.625rem 1rem !important;
      border: none !important;
      background: transparent !important;
      cursor: pointer !important;
      font-size: 0.9rem !important;
      color: #6b7280 !important;
      border-bottom: 2px solid transparent !important;
      transition: color 0.2s ease, border-color 0.2s ease !important;
    }

    .assist-mode-tab:hover {
      color: #1f2937 !important;
    }

    .assist-mode-tab.active {
      color: #5f6af2 !important;
      border-bottom-color: #5f6af2 !important;
      font-weight: 500 !important;
    }

    /* Action Chat */
    .action-chat-container {
      display: flex !important;
      flex-direction: column !important;
      height: 100% !important;
      min-height: 0 !important;
    }

    .action-chat-messages {
      flex: 1 !important;
      overflow-y: auto !important;
      display: flex !important;
      flex-direction: column !important;
      gap: 0.75rem !important;
      padding-bottom: 0.5rem !important;
    }

    .action-chat-placeholder {
      color: #6b7280 !important;
      font-size: 0.85rem !important;
      text-align: center !important;
      padding: 2rem 1rem !important;
      line-height: 1.5 !important;
    }

    .action-chat-msg {
      display: flex !important;
      max-width: 90% !important;
    }

    .action-chat-msg-user {
      align-self: flex-end !important;
    }

    .action-chat-msg-user .action-chat-msg-content {
      background: #5f6af2 !important;
      color: #ffffff !important;
      border-radius: 12px 12px 2px 12px !important;
      padding: 0.5rem 0.75rem !important;
      font-size: 0.9rem !important;
      line-height: 1.5 !important;
    }

    .action-chat-msg-assistant {
      align-self: flex-start !important;
    }

    .action-chat-msg-assistant .action-chat-msg-content {
      background: #f3f4f6 !important;
      color: #1f2937 !important;
      border-radius: 12px 12px 12px 2px !important;
      padding: 0.5rem 0.75rem !important;
      font-size: 0.9rem !important;
      line-height: 1.5 !important;
    }

    .action-chat-msg-assistant .action-chat-msg-content p {
      margin: 0.25rem 0 !important;
    }

    .action-chat-msg-assistant .action-chat-msg-content p:first-child {
      margin-top: 0 !important;
    }

    .action-chat-msg-assistant .action-chat-msg-content p:last-child {
      margin-bottom: 0 !important;
    }

    .action-chat-msg-error .action-chat-msg-content {
      background: #fef2f2 !important;
      color: #dc2626 !important;
      border: 1px solid #fecaca !important;
    }

    /* Confirmation card */
    .action-chat-confirm-card {
      margin-top: 0.5rem !important;
      padding: 0.75rem !important;
      background: #ffffff !important;
      border: 1px solid #dfe3ee !important;
      border-radius: 8px !important;
    }

    .action-chat-confirm-details {
      display: flex !important;
      flex-direction: column !important;
      gap: 0.25rem !important;
      margin-bottom: 0.5rem !important;
    }

    .action-chat-confirm-method {
      display: inline-block !important;
      background: #5f6af2 !important;
      color: #ffffff !important;
      font-size: 0.7rem !important;
      font-weight: 600 !important;
      padding: 0.125rem 0.375rem !important;
      border-radius: 3px !important;
      width: fit-content !important;
    }

    .action-chat-confirm-desc {
      font-size: 0.85rem !important;
      color: #374151 !important;
      font-weight: 500 !important;
    }

    .action-chat-confirm-body {
      background: #f9fafb !important;
      border: 1px solid #e5e7eb !important;
      border-radius: 4px !important;
      padding: 0.5rem !important;
      font-size: 0.75rem !important;
      overflow-x: auto !important;
      max-height: 150px !important;
      overflow-y: auto !important;
      margin: 0.25rem 0 0 0 !important;
      color: #374151 !important;
    }

    .action-chat-plan-steps {
      display: flex !important;
      flex-direction: column !important;
      gap: 0.5rem !important;
    }

    .action-chat-plan-step {
      background: #f9fafb !important;
      border: 1px solid #e5e7eb !important;
      border-radius: 6px !important;
      padding: 0.5rem !important;
      display: flex !important;
      flex-wrap: wrap !important;
      align-items: center !important;
      gap: 0.35rem !important;
    }

    .action-chat-step-num {
      font-weight: 600 !important;
      font-size: 0.7rem !important;
      color: #6b7280 !important;
      min-width: 3rem !important;
    }

    .action-chat-step-method {
      background: #dbeafe !important;
      color: #1d4ed8 !important;
      font-size: 0.65rem !important;
      font-weight: 600 !important;
      padding: 1px 5px !important;
      border-radius: 3px !important;
      text-transform: uppercase !important;
    }

    .action-chat-step-desc {
      font-size: 0.8rem !important;
      color: #374151 !important;
    }

    .action-chat-step-data {
      width: 100% !important;
      background: #fff !important;
      border: 1px solid #e5e7eb !important;
      border-radius: 4px !important;
      padding: 0.4rem !important;
      font-size: 0.7rem !important;
      overflow-x: auto !important;
      max-height: 120px !important;
      overflow-y: auto !important;
      margin: 0.15rem 0 0 0 !important;
      color: #374151 !important;
    }

    .action-chat-confirm-buttons {
      display: flex !important;
      gap: 0.5rem !important;
    }

    .action-chat-btn-confirm {
      flex: 1 !important;
      padding: 0.5rem !important;
      background: #5f6af2 !important;
      color: #ffffff !important;
      border: none !important;
      border-radius: 6px !important;
      cursor: pointer !important;
      font-size: 0.85rem !important;
      font-weight: 500 !important;
      transition: background 0.2s ease !important;
    }

    .action-chat-btn-confirm:hover {
      background: #4c56d9 !important;
    }

    .action-chat-btn-confirm:disabled {
      opacity: 0.6 !important;
      cursor: not-allowed !important;
    }

    .action-chat-btn-cancel {
      flex: 1 !important;
      padding: 0.5rem !important;
      background: #ffffff !important;
      color: #6b7280 !important;
      border: 1px solid #d1d5db !important;
      border-radius: 6px !important;
      cursor: pointer !important;
      font-size: 0.85rem !important;
      font-weight: 500 !important;
      transition: background 0.2s ease, border-color 0.2s ease !important;
    }

    .action-chat-btn-cancel:hover {
      background: #f9fafb !important;
      border-color: #9ca3af !important;
    }

    .action-chat-btn-cancel:disabled {
      opacity: 0.6 !important;
      cursor: not-allowed !important;
    }

    /* Chat input area */
    .action-chat-input-area {
      display: flex !important;
      gap: 0.5rem !important;
      align-items: flex-end !important;
      padding-top: 0.75rem !important;
      border-top: 1px solid #dfe3ee !important;
      flex-shrink: 0 !important;
      flex-wrap: wrap !important;
    }

    .action-chat-deep-search {
      display: flex !important;
      align-items: center !important;
      gap: 0.3rem !important;
      font-size: 0.75rem !important;
      color: #6b7280 !important;
      cursor: pointer !important;
      user-select: none !important;
      width: 100% !important;
      padding-bottom: 0.25rem !important;
    }

    .action-chat-deep-search input[type="checkbox"] {
      width: 14px !important;
      height: 14px !important;
      accent-color: #5f6af2 !important;
      cursor: pointer !important;
      margin: 0 !important;
    }

    .action-chat-deep-search span {
      line-height: 1 !important;
    }

    .action-chat-input {
      flex: 1 !important;
      resize: none !important;
      border: 1px solid #d1d5db !important;
      border-radius: 8px !important;
      padding: 0.5rem 0.75rem !important;
      font-size: 0.9rem !important;
      font-family: inherit !important;
      line-height: 1.5 !important;
      outline: none !important;
      transition: border-color 0.2s ease !important;
      max-height: 100px !important;
      overflow-y: auto !important;
    }

    .action-chat-input:focus {
      border-color: #5f6af2 !important;
    }

    .action-chat-input:disabled {
      background: #f9fafb !important;
    }

    .action-chat-send {
      width: 36px !important;
      height: 36px !important;
      border: none !important;
      background: #5f6af2 !important;
      color: #ffffff !important;
      border-radius: 8px !important;
      cursor: pointer !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      flex-shrink: 0 !important;
      transition: background 0.2s ease !important;
    }

    .action-chat-send:hover {
      background: #4c56d9 !important;
    }

    .action-chat-send:disabled {
      background: #d1d5db !important;
      cursor: not-allowed !important;
    }

    /* Typing indicator */
    .action-chat-typing {
      display: flex !important;
      gap: 4px !important;
      padding: 0.25rem 0 !important;
    }

    .action-chat-typing span {
      width: 6px !important;
      height: 6px !important;
      background: #9ca3af !important;
      border-radius: 50% !important;
      animation: action-chat-bounce 1.4s infinite ease-in-out both !important;
    }

    .action-chat-typing span:nth-child(1) { animation-delay: -0.32s !important; }
    .action-chat-typing span:nth-child(2) { animation-delay: -0.16s !important; }
    .action-chat-typing span:nth-child(3) { animation-delay: 0s !important; }

    @keyframes action-chat-bounce {
      0%, 80%, 100% { transform: scale(0); }
      40% { transform: scale(1); }
    }

    /* Stream status log (SSE progress) */
    .action-chat-stream-log {
      display: flex !important;
      flex-direction: column !important;
      gap: 0.2rem !important;
      max-height: 300px !important;
      overflow-y: auto !important;
    }

    .action-chat-stream-entry {
      display: flex !important;
      align-items: flex-start !important;
      gap: 0.35rem !important;
      font-size: 0.75rem !important;
      line-height: 1.4 !important;
      padding: 0.15rem 0 !important;
      font-family: 'SF Mono', 'Consolas', 'Monaco', monospace !important;
    }

    .action-chat-stream-icon {
      flex-shrink: 0 !important;
      font-size: 0.7rem !important;
      margin-top: 1px !important;
    }

    .action-chat-stream-status {
      color: #6b7280 !important;
    }

    .action-chat-stream-thinking {
      color: #7c3aed !important;
      font-style: italic !important;
      font-family: inherit !important;
      white-space: pre-wrap !important;
    }

    /* Workings panel (show workings) */
    .action-chat-workings {
      margin-top: 0.5rem !important;
      border: 1px solid #e5e7eb !important;
      border-radius: 6px !important;
      overflow: hidden !important;
    }

    .action-chat-workings-summary {
      padding: 0.4rem 0.75rem !important;
      background: #f9fafb !important;
      cursor: pointer !important;
      font-size: 0.8rem !important;
      font-weight: 500 !important;
      color: #6b7280 !important;
      user-select: none !important;
      list-style: none !important;
      display: flex !important;
      align-items: center !important;
      gap: 0.35rem !important;
      transition: background 0.2s ease, color 0.2s ease !important;
    }

    .action-chat-workings-summary::-webkit-details-marker {
      display: none !important;
    }

    .action-chat-workings-summary::before {
      content: '\\25B6' !important;
      font-size: 0.6rem !important;
      transition: transform 0.2s ease !important;
      display: inline-block !important;
    }

    .action-chat-workings[open] > .action-chat-workings-summary::before {
      transform: rotate(90deg) !important;
    }

    .action-chat-workings-summary:hover {
      background: #f3f4f6 !important;
      color: #374151 !important;
    }

    .action-chat-workings-content {
      padding: 0.5rem 0.75rem !important;
      background: #fafbfc !important;
      border-top: 1px solid #e5e7eb !important;
      font-size: 0.8rem !important;
      color: #4b5563 !important;
      line-height: 1.5 !important;
      max-height: 400px !important;
      overflow-y: auto !important;
    }

    .action-chat-workings-content p {
      margin: 0.25rem 0 !important;
    }

    .action-chat-workings-content ul,
    .action-chat-workings-content ol {
      margin: 0.25rem 0 !important;
      padding-left: 1.25rem !important;
    }

    .action-chat-workings-content li {
      margin: 0.15rem 0 !important;
    }

    .action-chat-workings-content strong {
      color: #374151 !important;
    }

    .action-chat-workings-content a {
      color: #5f6af2 !important;
      text-decoration: underline !important;
    }

    @media (max-width: 600px) {
      .assist-panel {
        width: 100% !important;
      }
    }
  `;
  document.head.appendChild(styleElement);
}

const resolveConfig = (overrides = {}) => {
  const currentScript =
    document.currentScript ||
    document.querySelector('script[data-assist-widget]');

  return {
    apiBaseUrl:
      overrides.apiBaseUrl ||
      currentScript?.getAttribute('data-api-base') ||
      'http://localhost:8081/api/v1',
    iconPosition:
      overrides.iconPosition ||
      currentScript?.getAttribute('data-assist-position') ||
      'top-right',
  };
};

const mountWidget = (configOverrides = {}) => {
  if (window.__assistWidgetMounted) {
    return;
  }

  const config = resolveConfig(configOverrides);
  const container = document.createElement('div');
  container.id = 'assist-widget-root';
  document.body.appendChild(container);

  const root = createRoot(container);
  root.render(<WidgetApp config={config} />);

  window.__assistWidgetMounted = true;
};

if (!window.AssistWidget) {
  window.AssistWidget = {
    init: mountWidget,
  };
}

mountWidget();

